/* eslint-disable eqeqeq */
import { sortedByNumber } from "../utils";

export const handleAllBookingCategoryExtra = (bId: any, bookingCategoriesExtras: any, cart: any, setNextButtonStatusIninital: any, nextButtonStatusIninital: any, setNextButtonStatus: any) => {
  let newArr: any = [...bookingCategoriesExtras];
  let extrasInfo: any = [];
  let arryExtraLimit: any = [];
  let localCart: any = []

  if (newArr && newArr.length > 0) {
    newArr.forEach((element: any) => {
      console.log(element, `element`);
      let objExtrasLimit = {
        id: element.id,
        title: element.title,
        limit: element.limit || null,
        min: element.min || null,
        max: element.max || null,
        unique: element.unique || 0,
        extras_length: element.extras.length,
        extras_category_name: element.title,
        required: element.required || null,
        order: element?.order ?? null,
        multiple: element.multiple,
      };
      if(element.min && element.min > 0 && nextButtonStatusIninital){
          setNextButtonStatus(false)
          setNextButtonStatusIninital(false)
        }
        
      element.extras.forEach((extraItem: any) => {
        let findCart = cart?.find((x: any) => (x.booking_extra_id == extraItem.id && x.bId == bId));
        const data = {
          category_extra_id: element.id,
          extra_id: extraItem.id,
          min: element.min || null,
          max: element.max || null,
          unique: element.unique || 0,
          extra: extraItem.name,
          image: extraItem.image,
          price: extraItem.price,
          quantity: findCart ? findCart.quantity : 0,
          maxQuantity: extraItem.quantity,
          multiple: element.multiple,
          hasFields: extraItem.hasFields,
          order: extraItem?.order ?? null,
        };
        if(findCart){
          localCart.push(findCart)
        }
        extrasInfo.push(data);
      });

      arryExtraLimit.push(objExtrasLimit);
    });

    sortedByNumber(arryExtraLimit)
  }

  return { localCart, arryExtraLimit, extrasInfo, };
};


